<div class="m-4">
  <p-button icon="pi pi-arrow-left" label="{{ 'BOTAO.VOLTAR' | translate }}" (onClick)="voltar()"/>
</div>
